/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ListAvailableNumber } from '../models/ListAvailableNumber';
import type { ListMessageResponse } from '../models/ListMessageResponse';
import type { PurchaseNumber } from '../models/PurchaseNumber';
import { request as __request } from '../core/request';

export class SmsService {

    /**
     * List available number for purchase
     * @returns ListAvailableNumber list of available numbers for purchase
     * @throws ApiError
     */
    public static async listAvailableNumbers({
contains,
areaCode,
}: {
contains?: string,
areaCode?: string,
}): Promise<ListAvailableNumber> {
        const result = await __request({
            method: 'GET',
            path: `/super-admin/phone/listAvailableNumbers`,
            query: {
                'contains': contains,
                'areaCode': areaCode,
            },
        });
        return result.body;
    }

    /**
     * Purchase number for sms
     * @returns any number added to company successfully
     * @throws ApiError
     */
    public static async purchaseNumber({
requestBody,
}: {
requestBody: PurchaseNumber,
}): Promise<any> {
        const result = await __request({
            method: 'POST',
            path: `/super-admin/phone/purchase-number`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * Get SMS history
     * @returns ListMessageResponse Company SMS history
     * @throws ApiError
     */
    public static async getSmsHistory({
companyId,
pageSize = 20,
pageToken,
sentTo,
after,
}: {
/** The company ID **/
companyId: number,
/** Number of messages per page **/
pageSize?: number,
/** Cursor token returned from a previous response to fetch the next page. Omit for the first page. **/
pageToken?: string,
/** Filter messages sent to this phone number (E.164 format) **/
sentTo?: string,
/** Filter messages sent after this date **/
after?: string,
}): Promise<ListMessageResponse> {
        const result = await __request({
            method: 'GET',
            path: `/companies/${companyId}/send-sms/listMessage`,
            query: {
                'pageSize': pageSize,
                'pageToken': pageToken,
                'sentTo': sentTo,
                'after': after,
            },
            errors: {
                400: `Invalid request parameters`,
                404: `Company not found or has no registered phone number`,
                500: `Internal server error`,
            },
        });
        return result.body;
    }

}